export const phoneDialogIndexEnums = {
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  OPENING: 'OPENING_PAGE_ONE',
  SUBMIT: 'PHONE_VERIFICATION_OR_CREATION_PAGE_TWO',
  PENDING: 'PHONE_VERIFICATION_SENT_THREE',
  SUCCESS: 'PHONE_VERIFICATION_SUCCESS',
};
